module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    attrs: {
      "align": "right"
    }
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "บันทึกผลยืนยัน"
    },
    on: {
      "click": _vm.openModel
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.mushroom_analysis.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("ไม่พบข้อมูล")])]) : _vm._l((_vm.mushroom_analysis), function(mushroom, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ชื่อเห็ดไทย: " + _vm._s(mushroom.mushroom_thai) + " "), _c('br'), _vm._v("\n             ชื่อวิทยาศาสตร์: " + _vm._s(mushroom.mushroom_science) + " "), _c('br'), _vm._v("\n             ประเภทเห็ด: {{}} "), _c('br')]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ผลการตรวจวิเคราะห์: " + _vm._s(mushroom.analysis_result) + " "), _c('br'), _vm._v("\n             สรุปผลการตรวจวิเคราะห์: " + _vm._s(mushroom.summary_result) + " "), _c('br'), _vm._v("\n             ผู้ตรวจวิเคราะห์: " + _vm._s(mushroom.analyst) + " "), _c('br'), _vm._v("\n             หมายเหตุ: " + _vm._s(mushroom.note) + " "), _c('br')]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ข้อมูลพื้นที่พบเห็ด "), _c('br'), _vm._v("\n             ต." + _vm._s(mushroom.ttname) + " อ." + _vm._s(mushroom.amname) + " จ." + _vm._s(mushroom.prv_name_th) + " "), _c('br'), _vm._v("\n             ละติจูด: " + _vm._s(mushroom.latitude) + "  "), _c('br'), _vm._v("\n             ลองจิจูด: " + _vm._s(mushroom.longitude) + "\n           ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteMushroomAnalysis(mushroom.id, mushroom.mushroom_thai)
        }
      }
    }, [_vm._v("\n               ลบ\n             ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      staticStyle: {
        "width": "80px",
        "margin-top": "8px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.gotoAlertToUser(mushroom.id)
        }
      }
    }, [_vm._v("\n               แจ้งเตือน\n             ")])])])
  })], 2)])])]), _vm._v(" "), (_vm.isModelAdd) ? _c('div', [_c('transition', {
    attrs: {
      "name": "model"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isModelAdd = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("บันทึกผลยืนยัน")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "500px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ข้อมูลพื้นที่พบเห็ด ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("จังหวัด")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pvcode),
      expression: "pvcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pvcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกจังหวัด --")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return (_vm.provinces.length > 0) ? _c('option', {
      domProps: {
        "value": province.pvcode
      }
    }, [_vm._v("\n                        " + _vm._s(province.prv_name_th) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("อำเภอ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amcode),
      expression: "amcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกอำเภอ --")]), _vm._v(" "), _vm._l((_vm.amphurs), function(amphur) {
    return (_vm.amphurs.length > 0) ? _c('option', {
      domProps: {
        "value": amphur.amcode
      }
    }, [_vm._v("\n                        " + _vm._s(amphur.amname) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ตำบล")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ttcode),
      expression: "ttcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ttcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกตำบล --")]), _vm._v(" "), _vm._l((_vm.tumbons), function(tumbon) {
    return (_vm.tumbons.length > 0) ? _c('option', {
      domProps: {
        "value": tumbon.ttcode
      }
    }, [_vm._v("\n                        " + _vm._s(tumbon.ttname) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.latLngCheck
    },
    on: {
      "change": function($event) {
        _vm.latLngCheck = !_vm.latLngCheck
      }
    }
  }), _vm._v(" ไม่สามารถระบุ ละติจูด ลองจิจูด ได้\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ละติจูด")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.latitude),
      expression: "latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "ละติจูด",
      "disabled": _vm.latLngCheck
    },
    domProps: {
      "value": (_vm.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.latitude = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ลองจิจูด")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longitude),
      expression: "longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "ลองจิจูด",
      "disabled": _vm.latLngCheck
    },
    domProps: {
      "value": (_vm.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.longitude = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ข้อมูลเห็ด ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_thai),
      expression: "mushroom_thai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด"
    },
    domProps: {
      "value": (_vm.mushroom_thai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_thai = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ชื่อวิทยาศาสตร์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_science),
      expression: "mushroom_science"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อวิทยาศาสตร์",
      "name": "mushroom_science"
    },
    domProps: {
      "value": (_vm.mushroom_science)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_science = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ประเภทเห็ด ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_type),
      expression: "mushroom_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mushroom_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mushroom_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ผลการวิเคราะห์ ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ผลการตรวจวิเคราะห์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analysis_result),
      expression: "analysis_result"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ผลการตรวจวิเคราะห์"
    },
    domProps: {
      "value": (_vm.analysis_result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.analysis_result = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("สรุปผลการตรวจวิเคราะห์")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.summary_result),
      expression: "summary_result"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "summary_result"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.summary_result = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ไม่ระบุ"
    }
  }, [_vm._v("ไม่ระบุ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "พบสารพิษ"
    }
  }, [_vm._v("พบสารพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ไม่พบสารพิษ"
    }
  }, [_vm._v("ไม่พบสารพิษ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ผู้ตรวจวิเคราะห์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analyst),
      expression: "analyst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ผู้ตรวจวิเคราะห์"
    },
    domProps: {
      "value": (_vm.analyst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.analyst = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("หมายเหตุ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "หมายเหตุ"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitAddData
    }
  }, [_vm._v("\n                     บันทึกข้อมูล\n                  ")])])])])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-left"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("ข้อมูลผลการยืนยันเห็ดพิษ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._v("\n       \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("ลำดับ")]), _vm._v(" "), _c('td', [_vm._v("ข้อมูลเห็ด")]), _vm._v(" "), _c('td', [_vm._v("ผลวิเคราะห์")]), _vm._v(" "), _c('td', [_vm._v("ข้อมูลพื้นที่")]), _vm._v(" "), _c('td', [_vm._v("แจ้งเตือน")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6307f258","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmAndAlert.vue
// module id = 1089
// module chunks = 1